if (!customElements.get('br-gallery-arrows')) {
  customElements.define('br-gallery-arrows', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.viewer = this.closest('slider-component');
      this.list = this.viewer?.querySelector('.product__media-list');
      if (!this.gallery || !this.list) return;
      this.onClick = (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button || typeof this.gallery.setActiveMedia !== 'function') return;
        const slides = this.visibleSlides();
        if (slides.length < 2) return;
        let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (window.matchMedia('(max-width: 749px)').matches) {
          current = slides.reduce((nearest, slide, index) =>
            Math.abs(slide.offsetLeft - this.list.scrollLeft) <
            Math.abs(slides[nearest].offsetLeft - this.list.scrollLeft) ? index : nearest, 0);
        }
        const next = (Math.max(0, current) + Number(button.dataset.direction) + slides.length) % slides.length;
        this.gallery.setActiveMedia(slides[next].dataset.mediaId, false);
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.list, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'hidden', 'data-br-rug-hidden']
      });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.viewer);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    visibleSlides() {
      return Array.from(this.list.querySelectorAll('.product__media-item[data-media-id]'))
        .filter((slide) => !slide.hidden && !slide.classList.contains('hidden') &&
          !slide.hasAttribute('data-br-rug-hidden'));
    }

    update() {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const slides = this.visibleSlides();
      this.hidden = slides.length < 2 ||
        desktop && !this.gallery.dataset.desktopLayout?.includes('thumbnail');
      if (this.hidden) return;
      const current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      const media = slides[current]?.querySelector('.product-media-container');
      if (media) {
        const bounds = media.getBoundingClientRect();
        const viewerBounds = this.viewer.getBoundingClientRect();
        this.style.top = String(bounds.top - viewerBounds.top + bounds.height / 2) + 'px';
        this.style.left = desktop ? String(Math.max(8, bounds.left - viewerBounds.left + 8)) + 'px' : '10px';
        this.style.right = desktop ? String(Math.max(8, viewerBounds.right - bounds.right + 8)) + 'px' : '10px';
      }
      if (desktop) {
        const counter = this.viewer.querySelector('.slider-counter--current');
        const total = this.viewer.querySelector('.slider-counter--total');
        if (counter) counter.textContent = String(current + 1);
        if (total) total.textContent = String(slides.length);
      }
    }
  });
}
